import { Injectable, Type } from '@angular/core';
import {
  ApiResponse,
  BaseApiService,
} from '@kinet-open-network/client/core/api-client';
import { mapToModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  downloadBlob,
  getFilenameFromHeaders,
} from '@kinet-open-network/client/shared/util';
import { IInvoiceItem } from '@kinet-open-network/shared/data-access/model';
import { firstValueFrom, map } from 'rxjs';
import { Closure } from '../models/closure.model';

@Injectable({
  providedIn: 'root',
})
export class ClosuresService extends BaseApiService<Closure> {
  override model: Type<Closure> = Closure;

  override get endpoint(): string {
    return '/invoicing/closures';
  }

  getClosureForCustomer(
    period: string,
    customerId: number,
  ): Promise<IInvoiceItem[]> {
    return firstValueFrom(
      this.http
        .get<
          ApiResponse<IInvoiceItem[]>
        >(`${this.endpoint}/customer/${customerId}/period/${period}`)
        .pipe(map((response) => response.data)),
    );
  }

  recompute(id: string): Promise<Closure> {
    return firstValueFrom(
      this.http
        .post<ApiResponse<Closure>>(`${this.endpoint}/${id}/recompute`, {})
        .pipe(mapToModel(Closure, 'data')),
    );
  }

  async exportItems(id: string, grouped = true): Promise<void> {
    const response = await firstValueFrom(
      this.http.get(`${this.endpoint}/${id}/export-items`, {
        params: { grouped },
        responseType: 'blob',
        observe: 'response',
      }),
    );
    const blob = response.body as Blob;
    const filename = getFilenameFromHeaders(response.headers);
    return downloadBlob(blob, filename ?? 'uzavierka-polozky.xlsx');
  }
}
